const JSONLD = ({center}) => {

    const schemaData = 
    {
        "@context": "https://schema.org/", 
        "@type": ["Organization","MedicalOrganization"], 
        "address": {
            "@type": "PostalAddress",
            "streetAddress": `${center.address_1} ${center.address_2}`,
            "addressLocality": `${center.city}`,
            "addressRegion": `${center.state}`,
            "postalCode":  `${center.zip}`,
            "addressCountry": "USA"
        },
        "url": `https://www.salubrishealth.com/find-doctors/centers/${center.friendly_url}`,
        "name": `${center.name}`,
        "contactPoint": {
            "@type": "ContactPoint",
            "telephone": `${center.phone}`,
            "faxNumber": `${center.fax}`,
            "contactType": "customer service"
        }
    };

    return (<script type="application/ld+json" dangerouslySetInnerHTML={{__html: JSON.stringify(schemaData)}} />);
}

export default JSONLD;